import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import creditScoringItemService from "services/Setup/CreditScoringItem/creditScoringItemService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  loadingSaveCreditScoring: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productList: {},
  refreshList: false,
  creditScoring: [],
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  statusRespon: 0,
  statusResponCreditAssessment: 0,
  statusResponCreditScoringKKB: 0,
};

export const posCalculate = createAsyncThunk(
  "creditScoringItem/posCalculate",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await creditScoringItemService.posCalculate(userInput);

      if (response.status === 200) {
        if (
          response.data.status == "Success" ||
          response.data.status == "Approved"
        ) {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posCreditScoringItemSave = createAsyncThunk(
  "creditScoringItem/posCreditScoringItemSave",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await creditScoringItemService.posCreditScoringItemSave(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posCalculateKKB = createAsyncThunk(
  "creditScoringItem/posCalculateKKB",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await creditScoringItemService.posCalculateKKB(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posCreditScoringItemSaveKKB = createAsyncThunk(
  "creditScoringItem/posCreditScoringItemSaveKKB",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await creditScoringItemService.posCreditScoringItemSaveKKB(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posCreditAssessmentSlice = createAsyncThunk(
  "creditScoringItem/posCreditAssessmentSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await creditScoringItemService.posCreditAssessmentService(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const creditScoringItem = createSlice({
  name: "creditScoringItem",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetStatusRespon: (state) => {
      state.statusRespon = 0;
      state.loading = false;
      state.statusResponCreditAssessment = 0;
      state.statusResponCreditScoringKKB = 0;
    },
  },

  extraReducers: (builder) => {
    builder
      //   post
      .addCase(posCalculate.pending, (state) => {
        state.loading = true;
      })
      .addCase(posCalculate.fulfilled, (state, action) => {
        console.log("actionposCalculate", action);

        state.loading = false;
        state.redirect = "/";
        state.creditScoring = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(posCalculate.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   post
      .addCase(posCreditScoringItemSave.pending, (state) => {
        state.loadingSaveCreditScoring = true;
      })
      .addCase(posCreditScoringItemSave.fulfilled, (state, action) => {
        state.loadingSaveCreditScoring = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(posCreditScoringItemSave.rejected, (state, action) => {
        state.loadingSaveCreditScoring = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //   post KKB
      .addCase(posCalculateKKB.pending, (state) => {
        state.loading = true;
      })
      .addCase(posCalculateKKB.fulfilled, (state, action) => {
        console.log("actionposCalculateKKB", action);
        state.loading = false;
        state.redirect = "/";
        state.creditScoring = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(posCalculateKKB.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //   post KKB
      .addCase(posCreditScoringItemSaveKKB.pending, (state) => {
        state.loadingSaveCreditScoring = true;
        state.statusResponCreditScoringKKB = 0;
      })
      .addCase(posCreditScoringItemSaveKKB.fulfilled, (state, action) => {
        state.loadingSaveCreditScoring = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusResponCreditScoringKKB = 200;
      })
      .addCase(posCreditScoringItemSaveKKB.rejected, (state, action) => {
        state.loadingSaveCreditScoring = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusResponCreditScoringKKB = 0;
      })
      //   post Credit Assessment
      .addCase(posCreditAssessmentSlice.pending, (state) => {
        state.loading = true;
        state.statusResponCreditAssessment = 0;
      })
      .addCase(posCreditAssessmentSlice.fulfilled, (state, action) => { 
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusResponCreditAssessment = 200;
      })
      .addCase(posCreditAssessmentSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusResponCreditAssessment = 0;
        state.statusRespon = 0;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
} = creditScoringItem.actions;

export default creditScoringItem.reducer;
